import React from 'react';
import { MenuItemType } from 'antd/lib/menu/hooks/useItems';

export const decisions: MenuItemType[] = [
  {
    title: 'Approved',
    label: (
      <>
        Approved
        <div
          className="media_viewer_actions-menu-icon"
          style={{ backgroundColor: '#A7D2A1' }}
        />
      </>
    ),
    key: 'approved'
  },
  {
    title: 'Approved with my feedback',
    label: (
      <>
        Approved with my feedback
        <div
          className="media_viewer_actions-menu-icon"
          style={{ backgroundColor: '#BFC5F4' }}
        />
      </>
    ),
    key: 'approved_with_feedback'
  },
  {
    title: 'Changes required',
    label: (
      <>
        Changes required
        <div
          className="media_viewer_actions-menu-icon"
          style={{ backgroundColor: '#F7CAB0' }}
        />
      </>
    ),
    key: 'changes_required'
  }
];
